/**
 * Custom events for prompt synchronization across components
 */

import type { PinnedContext } from '@shaarp/common';

export const PROMPT_EVENTS = {
  PROMPTS_CHANGED: "promptsChanged",
  PINNED_CHANGED: "pinnedChanged",
  FAVORITES_CHANGED: "favoritesChanged",
} as const;

export type PinnedChangedEvent = CustomEvent<{
  pinnedIds: string[];
  context: PinnedContext;
}>;
export type FavoritesChangedEvent = CustomEvent<{ favoriteIds: string[] }>;

/**
 * Dispatch an event when prompts are created, updated, or deleted
 */
export function notifyPromptsChanged(): void {
  window.dispatchEvent(new CustomEvent(PROMPT_EVENTS.PROMPTS_CHANGED));
}

/**
 * Dispatch an event when pinned prompts change
 */
export function notifyPinnedChanged(
  pinnedIds: string[],
  context: PinnedContext,
): void {
  window.dispatchEvent(
    new CustomEvent(PROMPT_EVENTS.PINNED_CHANGED, {
      detail: { pinnedIds, context },
    }),
  );
}

/**
 * Dispatch an event when favorite prompts change
 */
export function notifyFavoritesChanged(favoriteIds: string[]): void {
  window.dispatchEvent(
    new CustomEvent(PROMPT_EVENTS.FAVORITES_CHANGED, {
      detail: { favoriteIds },
    }),
  );
}
